// Recovered compiled webpack factory 46436. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { E: () => s });
  var n = i(12115);
  let s = "undefined" != typeof window ? n.useLayoutEffect : n.useEffect;
}
